import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router-dom'
import { useUserCourse } from '../hooks/queries/useUserCourses'
import { useCourseNavigation } from '../hooks/useCourseNavigation'

export const Dashboard = () => {
    const { t } = useTranslation('content')

    const { slugOrId } = useParams()
    const { courseSlug, isLoading } = useUserCourse(slugOrId)
    const { buildCourseUrl } = useCourseNavigation()

    const existCourseSlug = !!courseSlug && courseSlug.length > 0

    const url = buildCourseUrl(existCourseSlug ? courseSlug : slugOrId ?? '')

    if (isLoading) return <p>{t('Redirecting to course...')}</p>

    return <Navigate to={url} />
}
